<template>
  <div class="pega-login-container grid-y">
    <div class="cell">
      <div class="grid-x align-center">
        <div class="cell large-5 medium-8 small-10 pega-login-content">
          <div class="text-center">
            <div class="font-bold">
              ひとつ上を目指す人のキャリア転職サイト 【タイプ】
            </div>
            <img
              class="pega-logo margin-bottom-2"
              src="@/assets/images/type-logo.png"
            >
          </div>
          <form
            @submit.prevent="login"
          >
            <p class="margin-0 pega-font-size-min-rem">
              ログインID
            </p>
            <div class="form-group">
              <input
                id="loginId"
                v-model="loginId"
                :class="{ 'is-invalid-input' : isInvalidLoginId }"
                data-test="login-id"
                type="text"
                placeholder="ログインID"
              >
              <validation-label
                v-if="isInvalidLoginId"
                data-test="login-id-validation"
                label="ログインIDが誤っています。（メールアドレスではありませんのでご注意ください）"
              />
            </div>
            <p class="margin-0 pega-font-size-min-rem">
              パスワード
            </p>
            <div class="form-group">
              <input
                id="loginPassword"
                v-model="loginPassword"
                data-test="login-password"
                type="password"
                placeholder="パスワード"
              >
            </div>
            <button
              :disabled="isDisable"
              class="float-center boss-button-center pega-login-button pega-button"
              data-test="login-button"
              type="submit"
            >
              ログイン
            </button>
            <div class="margin-top-2 text-center">
              <a
                :href="'/help/faq/002.html'"
                class="pega-login-help-link"
                target="_blank"
                data-test="link-help"
              ><span>＞ID・パスワードをお忘れの方はこちら</span>
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import ValidationLabel from '@/components/atoms/ValidationLabel'
export default {
  components: {
    ValidationLabel
  },
  data () {
    return {
      loginId: '',
      loginPassword: ''
    }
  },
  computed: {
    isDisable () {
      return _.isEmpty(this.loginId) ||
        _.isEmpty(this.loginPassword) ||
        this.isInvalidLoginId
    },
    isInvalidLoginId () {
      return !/^[a-zA-Z_0-9]*$/.test(this.loginId)
    }
  },
  created () {
    this.$http.plain.get('api/is_authentication').then(response => {
      if (response.data) {
        this.$router.push({ name: 'dashboardTop' })
      }
    })
  },
  methods: {
    ...mapActions('contracts', [
      'clearContracts'
    ]),
    ...mapActions('settings', [
      'clearSettings'
    ]),
    ...mapActions([
      'clearUser',
      'clearSearchCondition',
      'clearMaster',
      'storeMaster',
      'clearIsEnabledDtype'
    ]),
    login () {
      // TODO plainとsecuredの別けをどうするか
      this.$http.plain.post('api/login', { loginId: this.loginId, loginPassword: this.loginPassword })
        .then(response => {
          // storeをリフレッシュ
          this.clearStore()
          // 取得
          this.fetchAllMasters()
          this.loginSuccessful()
        }).catch((error) => {
          const status = _.get(error, 'response.data.status')
          const message = _.get(error, 'response.data.message')
          this.$toasted.global.error({ message: status === 403 ? message : 'ログインに失敗しました。' })
        })
    },
    loginSuccessful () {
      this.$store.dispatch('setIsEnabledDtype')
      this.fetchStaffInfo().then(response => {
        this.$store.dispatch('setCurrentUser', { currentUser: response.data })
        // ダミー権限が有効な場合ダミー画面へ
        response.data.permissions.isCountScoutUserSimulation ? this.$router.push({ name: 'dummyTop' }) : this.$router.push({ name: 'dashboardTop' })
      })
    },
    fetchStaffInfo () {
      return this.$http.secured.get('/staff_info')
    },
    clearStore () {
      this.clearContracts()
      this.clearSettings()
      this.clearMaster()
      this.clearUser()
      this.clearSearchCondition()
      this.clearIsEnabledDtype()
    },
    fetchAllMasters () {
      const masters = [
        'genders',
        'educationalBackgrounds',
        'prefectures',
        'occupations',
        'changeJobsMotivations',
        'companyStyles',
        'skills',
        'licenses',
        'specialFavors',
        'businesses',
        'employmentStatuses',
        'evaluations',
        'languageSkills',
        'interviewContents',
        'optionalPermissions',
        'receivableMailTypes',
        'autoReplyMailSchedules',
        'entryFormTypes'
      ]
      masters.forEach(element => {
        this.storeMaster(element)
      })
    }
  }
}
</script>
